import React from "react";
import './mySkillHome.css';

import SkillStart from "./skillStart";
import SkillShow from "./skillShow";
import SkillFinish from './skillFinish';
import RecordShow from "./recordShow";

const MySkillHome = () => {
  return (
    <div className="ms-home">
       <div className="ms-home-inner">
          <SkillStart />
       </div>       
    </div>
  );
};
export default MySkillHome;
